const CardItem = ({ item, index }) => {
	const formatDate = (val) => (val ? val.split("T")[0] : "-");

	return (
		<tr key={index} className="text-center">
			<td>
				<strong>{item?.employee?.id || "-"}</strong>
			</td>
			<td>{item?.employee?.name || "-"}</td>
			<td>{item?.employee?.companyEmail || "-"}</td>
			<td>{item?.employee?.department?.name || "-"}</td>
			<td>{formatDate(item?.departureDay)}</td>
			<td>{formatDate(item?.returnDay)}</td>
			<td>{item?.reason || "-"}</td>
			<td>{item?.numberOfDays ?? "-"}</td>
			<td>
				{item?.attachmentUrl ? (
					<a href={item.attachmentUrl} target="_blank" rel="noreferrer">
						<i className="la la-file-pdf" style={{ fontSize: "2.5rem" }}></i>
					</a>
				) : (
					"-"
				)}
			</td>
		</tr>
	);
};
export default CardItem;
